import { defineStore } from "pinia"
import type { RentalIntakeMaterialization } from "@/models/rental-intake-materialization.model.ts"
import { computed, ref, type Ref } from "vue"

export const useRentalIntakeMaterializationStore = defineStore(
  "rentalIntakeMaterializationStore",
  () => {
    const rentalIntakeMaterializations: Ref<RentalIntakeMaterialization[]> = ref([])

    const outstandingRentalIntakeMaterializations = computed(() =>
      rentalIntakeMaterializations.value.filter((rim) => rim.isOutstanding())
    )

    return {
      rentalIntakeMaterializations,
      outstandingRentalIntakeMaterializations
    }
  }
)
